import React from "react"

const Twitter = () => (
	<svg
		width="20"
		height="17"
		xmlns="http://www.w3.org/2000/svg"
		className="inline-block fill-current align-middle">
		<path
			d="M17.644 2.688A4.264 4.264 0 0019.447.314a7.995 7.995 0 01-2.606 1.041A4.009 4.009 0 0013.846 0c-2.265 0-4.101 1.921-4.101 4.291 0 .337.034.664.104.977C6.44 5.09 3.417 3.383 1.392.785a4.432 4.432 0 00-.555 2.158c0 1.488.724 2.802 1.825 3.573a3.981 3.981 0 01-1.859-.537v.053c0 2.08 1.413 3.815 3.293 4.208a3.85 3.85 0 01-1.083.15 3.89 3.89 0 01-.77-.075c.52 1.704 2.036 2.946 3.832 2.98A8.006 8.006 0 010 15.072 11.254 11.254 0 006.29 17c7.548 0 11.673-6.54 11.673-12.21 0-.187-.002-.372-.01-.555A8.532 8.532 0 0020 2.012a7.914 7.914 0 01-2.356.676z"
			fillRule="evenodd"
		/>
	</svg>
)

export default Twitter
